import { useAction, useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { AsyncStateN, Array } from '@blade/std-lib'
import { InfoMessage } from '@root/shared/ui-kit'

import { UserConnectionsFollower } from './user-connections-follower'
import { UserConnectionsItem } from './user-connections-item/user-connections-item'

import type { FollowersFilter } from '../atoms/user-followers-filter'

type Props = {
  followersFilter: FollowersFilter
}

export const UserConnectionsFollowers = ({ followersFilter }: Props) => {
  const [filterItemsState] = useAtom(followersFilter.filterItemsStateAtom)
  const refreshFilter = useAction(followersFilter.filterItemsStateAtom.refresh)

  return AsyncStateN.matchWaiting(filterItemsState, {
    Error: () => (
      <InfoContainer>
        <InfoMessage intent={'error'} variant="dt" onRetry={refreshFilter} />
      </InfoContainer>
    ),
    Waiting: () => (
      <FilterResult>
        {Array.range(0, 5).map((x) => (
          <UserConnectionsItem.Skeleton key={x} />
        ))}
      </FilterResult>
    ),
    Success: (followings) =>
      followings.length <= 0 ? (
        <InfoContainer>
          <InfoMessage intent={'empty'} variant="dt" />
        </InfoContainer>
      ) : (
        <FilterResult>
          {followings.map((following) => (
            <UserConnectionsFollower
              follower={following}
              key={following.delugeId}
            />
          ))}
        </FilterResult>
      ),
  })
}

const FilterResult = styled.div`
  z-index: 0;
  display: grid;
  grid-auto-rows: max-content;
  gap: 6px;
`
const InfoContainer = styled.div`
  display: grid;
`
